import { useDispatch, useSelector } from "../../../hooks";
import { buyDrawTicket } from "../../../redux/draws/buy-ticket.handler";
import { FC, MouseEvent } from "react";
import { DrawCard } from "../../../components/DrawCard/DrawCard";
import { IDraw } from "../DrawItem";
import { setTicketsBalanceError, setUserBalance, setUserExp, setUserTickets } from "../../../redux/user";
import { omit } from "lodash";
import { TicketType } from "../../../components/TicketsPanel/Ticket";
import { resolveDrawCostCurrency } from "./draw-cost";

interface IDrawCardAvailableProps {
    draw: IDraw;
    setJoinChannelPopup: (state: boolean) => void;
}

export const DrawCardAvailable: FC<IDrawCardAvailableProps> = ({ draw, setJoinChannelPopup }) => {
    const dispatch = useDispatch();
    const tickets = useSelector(store => store.user.info.tickets);

    const handler = async (event: MouseEvent<HTMLButtonElement>, amount: number) => {
        if (event)
            event.stopPropagation();
        
        if (!draw)
            return;

        const ticketType = resolveDrawCostCurrency(draw.cost);
        if (!ticketType)
            return;

        if (tickets[ticketType] < draw.cost[ticketType]) {
            dispatch(setTicketsBalanceError({
                ticketType: ticketType as TicketType,
                amount: draw.cost[ticketType],
            }));
            return;
        }

        const resultAction = await dispatch(buyDrawTicket({ drawId: draw.drawId, amount }));
        if (buyDrawTicket.fulfilled.match(resultAction)) {            
            const { balances, isSubscriber, exp } = resultAction.payload;

            if (balances !== undefined) {
                const tickets = omit(balances, 'balance');
                dispatch(setUserTickets(tickets));
                balances.balance && dispatch(setUserBalance({ balance: balances.balance }));
            }

            if (exp !== undefined)
                dispatch(setUserExp(exp));

            if (!isSubscriber)
                setJoinChannelPopup(true);
        }
    }

    return <DrawCard draw={ draw } handler={ handler } />
};